"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _search = _interopRequireDefault(require("../util/search"));

var _cyclicIncrementor = _interopRequireDefault(require("../util/cyclicIncrementor"));

var _error = require("../error");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var idGenerator = (0, _cyclicIncrementor.default)(1);
var jobs = {};
var subscriptions = {};
var userIdGenerators = {};
var status = {
  PENDING: 'pending',
  RUNNING: 'running',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

var localIdGenerator = function localIdGenerator(userId) {
  if (!userIdGenerators[userId]) {
    userIdGenerators[userId] = (0, _cyclicIncrementor.default)(1);
  }

  return userIdGenerators[userId];
};

var job = function job() {
  return function () {
    var list = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Object.values(jobs));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function list() {
        return _ref.apply(this, arguments);
      };
    }();

    var _ref2 = (0, _search.default)(list),
        find = _ref2.find,
        findOne = _ref2.findOne;

    return {
      subscribe: function subscribe(id, handler) {
        if (!subscriptions[id]) subscriptions[id] = [];
        subscriptions[id].push(handler);
        return {
          unsubscribe: function unsubscribe() {
            subscriptions[id] = subscriptions[id].filter(function (fn) {
              return fn !== handler;
            });
          }
        };
      },
      create: function create(userId, overrides) {
        var jobId = idGenerator.next();
        var localId = localIdGenerator(userId).next(); // TODO: reset the generator if there are no jobs for the user

        var newJob = _objectSpread({
          // TODO: use joi for schema validation
          id: jobId,
          localId: localId,
          userId: userId,
          context: null,
          command: null,
          source: null,
          status: status.PENDING,
          started: Date.now(),
          finished: null,
          output: null
        }, overrides);

        jobs[jobId] = newJob;
        return newJob;
      },
      update: function update(id, updates) {
        // TODO: use joi for schema validation
        if (!jobs[id]) {
          throw new _error.SearchError("No such job with id ".concat(id));
        }

        var updated = _objectSpread({}, jobs[id], {}, updates);

        if (subscriptions[id]) {
          subscriptions[id].forEach(function (fn) {
            return fn(updated, job[id]);
          });
        }

        jobs[id] = updated;
        return updated;
      },
      destroy: function destroy(id) {
        delete jobs[id];
        delete subscriptions[id];
      },
      status: status,
      find: find,
      findOne: findOne,
      list: list
    };
  };
};

var _default = job;
exports.default = _default;